import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // close menu on route change (optional: if you use a router listener, remove if not needed)
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 980 && menuOpen) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [menuOpen]);

  const toggleMenu = () => setMenuOpen((v) => !v);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="navbar-wrap">
      <nav className="navbar" role="navigation" aria-label="Main">
        {/* Logo */}
        <div className="logo">
          <Link to="/" aria-label="Go to Home" onClick={closeMenu}>
            <img src={logo} alt="Site Logo" />
          </Link>
        </div>

        {/* Links */}
        <ul className={`nav-links ${menuOpen ? "show" : ""}`} id="primary-navigation">
          <li>
            <NavLink to="/" end onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/services" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Services
            </NavLink>
          </li>
          <li>
            <NavLink to="/gallery" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Gallery
            </NavLink>
          </li>
          <li>
            <NavLink to="/testimonials" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Testimonials
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Contact
            </NavLink>
          </li>

          {/* Mobile CTA at bottom */}
          <li className="apply-mobile">
            <Link to="/apply" className="apply-btn" onClick={closeMenu}>
              Apply Now
            </Link>
          </li>
        </ul>

        {/* Right side actions */}
        <div className="nav-actions">
          {/* Desktop CTA */}
          <Link to="/apply" className="apply-btn apply-desktop">
            Apply Now
          </Link>

          {/* Hamburger */}
          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            aria-controls="primary-navigation"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
